export const countryCodesMap = new Map([
  ['CHN', 'China'],
  ['IND', 'India'],
  ['USA', 'United States'],
  ['IDN', 'Indonesia'],
  ['PAK', 'Pakistan'],
  ['BRA', 'Brazil'],
  ['NGA', 'Nigeria'],
  ['BGD', 'Bangladesh'],
  ['RUS', 'Russia'],
  ['MEX', 'Mexico'],
  ['JPN', 'Japan'],
  ['ETH', 'Ethiopia'],
  ['PHL', 'Philippines'],
  ['EGY', 'Egypt'],
  ['VNM', 'Vietnam'],
  ['COD', 'DR Congo'],
  ['TUR', 'Turkey'],
  ['IRN', 'Iran'],
  ['DEU', 'Germany'],
  ['THA', 'Thailand'],
  ['GBR', 'United Kingdom'],
  ['FRA', 'France'],
  ['ITA', 'Italy'],
  ['TZA', 'Tanzania'],
  ['ZAF', 'South Africa'],
  ['MMR', 'Myanmar'],
  ['KEN', 'Kenya'],
  ['KOR', 'South Korea'],
  ['COL', 'Colombia'],
  ['ESP', 'Spain'],
  ['UGA', 'Uganda'],
  ['ARG', 'Argentina'],
  ['DZA', 'Algeria'],
  ['SDN', 'Sudan'],
  ['UKR', 'Ukraine'],
  ['IRQ', 'Iraq'],
  ['AFG', 'Afghanistan'],
  ['POL', 'Poland'],
  ['CAN', 'Canada'],
  ['MAR', 'Morocco'],
  ['SAU', 'Saudi Arabia'],
  ['UZB', 'Uzbekistan'],
  ['PER', 'Peru'],
  ['AGO', 'Angola'],
  ['MYS', 'Malaysia'],
  ['MOZ', 'Mozambique'],
  ['GHA', 'Ghana'],
  ['YEM', 'Yemen'],
  ['NPL', 'Nepal'],
  ['VEN', 'Venezuela'],
  ['MDG', 'Madagascar'],
  ['CMR', 'Cameroon'],
  ['CIV', 'Ivory Coast'],
  ['PRK', 'North Korea'],
  ['AUS', 'Australia'],
  ['NER', 'Niger'],
  ['TWN', 'Taiwan'],
  ['LKA', 'Sri Lanka'],
  ['BFA', 'Burkina Faso'],
  ['MLI', 'Mali'],
  ['ROU', 'Romania'],
  ['MWI', 'Malawi'],
  ['CHL', 'Chile'],
  ['KAZ', 'Kazakhstan'],
  ['ZMB', 'Zambia'],
  ['GTM', 'Guatemala'],
  ['ECU', 'Ecuador'],
  ['SYR', 'Syria'],
  ['NLD', 'Netherlands'],
  ['SEN', 'Senegal'],
  ['KHM', 'Cambodia'],
  ['TCD', 'Chad'],
  ['SOM', 'Somalia'],
  ['ZWE', 'Zimbabwe'],
  ['GIN', 'Guinea'],
  ['RWA', 'Rwanda'],
  ['BEN', 'Benin'],
  ['BDI', 'Burundi'],
  ['TUN', 'Tunisia'],
  ['BOL', 'Bolivia'],
  ['BEL', 'Belgium'],
  ['HTI', 'Haiti'],
  ['CUB', 'Cuba'],
  ['SSD', 'South Sudan'],
  ['DOM', 'Dominican Republic'],
  ['CZE', 'Czechia'],
  ['GRC', 'Greece'],
  ['JOR', 'Jordan'],
  ['PRT', 'Portugal'],
  ['AZE', 'Azerbaijan'],
  ['SWE', 'Sweden'],
  ['HND', 'Honduras'],
  ['ARE', 'United Arab Emirates'],
  ['HUN', 'Hungary'],
  ['TJK', 'Tajikistan'],
  ['BLR', 'Belarus'],
  ['AUT', 'Austria'],
  ['PNG', 'Papua New Guinea'],
  ['SRB', 'Serbia'],
  ['ISR', 'Israel'],
  ['CHE', 'Switzerland'],
  ['TGO', 'Togo'],
  ['SLE', 'Sierra Leone'],
  ['HKG', 'Hong Kong'],
  ['LAO', 'Laos'],
  ['PRY', 'Paraguay'],
  ['BGR', 'Bulgaria'],
  ['LBY', 'Libya'],
  ['LBN', 'Lebanon'],
  ['NIC', 'Nicaragua'],
  ['KGZ', 'Kyrgyzstan'],
  ['SLV', 'El Salvador'],
  ['TKM', 'Turkmenistan'],
  ['SGP', 'Singapore'],
  ['DNK', 'Denmark'],
  ['FIN', 'Finland'],
  ['COG', 'Republic of the Congo'],
  ['SVK', 'Slovakia'],
  ['NOR', 'Norway'],
  ['OMN', 'Oman'],
  ['PSE', 'Palestine'],
  ['CRI', 'Costa Rica'],
  ['HRV', 'Croatia'],
  ['LBR', 'Liberia'],
  ['IRL', 'Ireland'],
  ['CAF', 'Central African Republic'],
  ['NZL', 'New Zealand'],
  ['MRT', 'Mauritania'],
  ['PAN', 'Panama'],
  ['KWT', 'Kuwait'],
  ['MDA', 'Moldova'],
  ['GEO', 'Georgia'],
  ['ERI', 'Eritrea'],
  ['URY', 'Uruguay'],
  ['BIH', 'Bosnia and Herzegovina'],
  ['MNG', 'Mongolia'],
  ['ARM', 'Armenia'],
  ['JAM', 'Jamaica'],
  ['QAT', 'Qatar'],
  ['ALB', 'Albania'],
  ['PRI', 'Puerto Rico'],
  ['LTU', 'Lithuania'],
  ['NAM', 'Namibia'],
  ['GMB', 'Gambia'],
  ['BWA', 'Botswana'],
  ['GAB', 'Gabon'],
  ['LSO', 'Lesotho'],
  ['MKD', 'North Macedonia'],
  ['SVN', 'Slovenia'],
  ['GNB', 'Guinea-Bissau'],
  ['KOS', 'Kosovo'],
  ['LVA', 'Latvia'],
  ['BHR', 'Bahrain'],
  ['GNQ', 'Equatorial Guinea'],
  ['TTO', 'Trinidad and Tobago'],
  ['EST', 'Estonia'],
  ['TLS', 'Timor-Leste'],
  ['MUS', 'Mauritius'],
  ['CYP', 'Cyprus'],
  ['SWZ', 'Eswatini'],
  ['DJI', 'Djibouti'],
  ['FJI', 'Fiji'],
  ['REU', 'Réunion'],
  ['COM', 'Comoros'],
  ['GUY', 'Guyana'],
  ['BTN', 'Bhutan'],
  ['SLB', 'Solomon Islands'],
  ['MAC', 'Macau'],
  ['MNE', 'Montenegro'],
  ['LUX', 'Luxembourg'],
  ['ESH', 'Western Sahara'],
  ['SUR', 'Suriname'],
  ['CPV', 'Cape Verde'],
  ['FSM', 'Micronesia'],
  ['MDV', 'Maldives'],
  ['MLT', 'Malta'],
  ['BRN', 'Brunei'],
  ['GLP', 'Guadeloupe'],
  ['BLZ', 'Belize'],
  ['BHS', 'Bahamas'],
  ['MTQ', 'Martinique'],
  ['ISL', 'Iceland'],
  ['VUT', 'Vanuatu'],
  ['GUF', 'French Guiana'],
  ['BRB', 'Barbados'],
  ['NCL', 'New Caledonia'],
  ['PYF', 'French Polynesia'],
  ['MYT', 'Mayotte'],
  ['STP', 'São Tomé and Príncipe'],
  ['WSM', 'Samoa'],
  ['LCA', 'Saint Lucia'],
  ['GUM', 'Guam'],
  ['CUW', 'Curaçao'],
  ['KIR', 'Kiribati'],
  ['GRD', 'Grenada'],
  ['VCT', 'Saint Vincent and the Grenadines'],
  ['ABW', 'Aruba'],
  ['TON', 'Tonga'],
  ['VIR', 'United States Virgin Islands'],
  ['JEY', 'Jersey'],
  ['SYC', 'Seychelles'],
  ['ATG', 'Antigua and Barbuda'],
  ['IMN', 'Isle of Man'],
  ['AND', 'Andorra'],
  ['DMA', 'Dominica'],
  ['CYM', 'Cayman Islands'],
  ['GGY', 'Guernsey'],
  ['BMU', 'Bermuda'],
  ['MHL', 'Marshall Islands'],
  ['MNP', 'Northern Mariana Islands'],
  ['GRL', 'Greenland'],
  ['ASM', 'American Samoa'],
  ['KNA', 'Saint Kitts and Nevis'],
  ['FRO', 'Faroe Islands'],
  ['SXM', 'Sint Maarten'],
  ['MCO', 'Monaco'],
  ['TCA', 'Turks and Caicos Islands'],
  ['MAF', 'Saint Martin'],
  ['LIE', 'Liechtenstein'],
  ['SMR', 'San Marino'],
  ['GIB', 'Gibraltar'],
  ['VGB', 'British Virgin Islands'],
  ['ALA', 'Åland Islands'],
  ['BES', 'Caribbean Netherlands'],
  ['PLW', 'Palau'],
  ['COK', 'Cook Islands'],
  ['AIA', 'Anguilla'],
  ['TUV', 'Tuvalu'],
  ['WLF', 'Wallis and Futuna'],
  ['NRU', 'Nauru'],
  ['BLM', 'Saint Barthélemy'],
  ['SHN', 'Saint Helena'],
  ['SPM', 'Saint Pierre and Miquelon'],
  ['MSR', 'Montserrat'],
  ['FLK', 'Falkland Islands'],
  ['IOT', 'British Indian Ocean Territory'],
  ['SJM', 'Svalbard and Jan Mayen'],
  ['NFK', 'Norfolk Island'],
  ['CXR', 'Christmas Island'],
  ['NIU', 'Niue'],
  ['TKL', 'Tokelau'],
  ['VAT', 'Vatican City'],
  ['CCK', 'Cocos (Keeling) Islands'],
  ['UMI', 'United States Minor Outlying Islands'],
  ['ATF', 'French Southern and Antarctic Lands'],
  ['PCN', 'Pitcairn Islands'],
  ['SGS', 'South Georgia'],
]);
